import { router } from 'expo-router';
import {
    BackButton,
    BackButtonIconType,
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    FullScreenContainer,
    H2Emphasized,
    Image,
    isWeb,
    ScrollView,
    YStack,
} from 'smoothie';

import PaycheckRoutingInfo from '../../../../../assets/images/banking/paycheck-routing/paycheck-routing-info.png';
import { useViewEvents } from '../../../../events/hooks/useViewEvents';

const NoPaycheckDetected = () => {
    const { trackViewOnce } = useViewEvents();
    trackViewOnce('Banking/PaycheckRouting/NoPaycheckDetected');

    const closeAction = () => {
        router.replace('/banking/direct-deposit/info');
    };
    return (
        <FullScreenContainer
            header={
                <BackButton
                    fallbackRoute="/"
                    iconType={BackButtonIconType.LEFT}
                />
            }
            separator={true}
            footer={
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Set up direct deposit"
                    onPress={closeAction}
                />
            }
        >
            <ScrollView showsVerticalScrollIndicator={isWeb}>
                <YStack>
                    <Image
                        source={PaycheckRoutingInfo}
                        style={{
                            height: 290,
                            alignSelf: 'center',
                            aspectRatio: 'auto',
                            marginTop: 24,
                        }}
                        resizeMode="contain"
                    />
                    <YStack gap={12}>
                        <H2Emphasized>
                            Direct deposit to Fruitful and auto-split your
                            paycheck
                        </H2Emphasized>
                        <BodyMediumRegular color="$gray1000">
                            Set up rules that direct every dollar to power your
                            lifestyle and goals. When income arrives, auto-split
                            it across accounts based on your priorities.
                        </BodyMediumRegular>
                        <BodyMediumRegular color="$gray1000">
                            Move your direct deposit to a Fruitful Cash account
                            through your payroll provider to get started.
                        </BodyMediumRegular>
                    </YStack>
                </YStack>
            </ScrollView>
        </FullScreenContainer>
    );
};

export default NoPaycheckDetected;
